import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/organizer-associations',
    name: 'organization-associations',
    component: () => import('./views/event-associations.vue'),
    meta: {
      title: 'Ассоциации',
      layout: 'ui-design',
      icon: '$ifolder-favorite-outline',
      accessList: [ROLES.organization],
    },
  },
  {
    path: '/organizer-association/:id',
    name: 'organization-association',
    component: () => import('./views/event-association.vue'),
    meta: {
      title: 'Ассоциация',
      layout: 'ui-design',
      back: true,
      accessList: [ROLES.organization],
    },
  },
];
